import React, { useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';

export default function BrandLogo({
  src,
  alt = 'HOT WIFI',
  maxWidth = 220,
  showFallbackTagline = false,
  imageSx = {},
}) {
  const [imageFailed, setImageFailed] = useState(false);

  const resolvedSrc = useMemo(() => src || '/hotwifi-logo.png', [src]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {!imageFailed && (
        <Box
          component="img"
          src={resolvedSrc}
          alt={alt}
          onError={() => setImageFailed(true)}
          sx={{
            width: '100%',
            maxWidth,
            height: 'auto',
            objectFit: 'contain',
            ...imageSx,
          }}
        />
      )}

      {imageFailed && (
        <>
          <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: 1 }}>
            HOT WIFI
          </Typography>
          {showFallbackTagline && (
            <Typography variant="caption" sx={{ mt: 0.5, letterSpacing: 1.2, opacity: 0.9 }}>
              INTEGRATE | ELEVATE | ACCELERATE
            </Typography>
          )}
        </>
      )}
    </Box>
  );
}
